import { render } from "./PlayerVue.vue?vue&type=template&id=30185c06"
const script = {}

import "./PlayerVue.vue?vue&type=style&index=0&id=30185c06&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__